import { Props } from '~/containers/AdditionalDriverDetails';

function meetsDataDependencies(props: Props) {
  const {
    application: { autoApplicants },
  } = props;

  return autoApplicants.length > 0;
}

const step = {
  route: '/homeowners-insurance/quotes/additional-driver-details',
  breadcrumbStep: 'auto',
  isAccessible: ({ application }: Props): boolean => application.bundled || application.isAutoOnly,
  meetsDataDependencies,
};

export default step;
